"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dataTypeLabel = exports.DataType = void 0;
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
// eslint-disable-next-line no-shadow
var DataType;
(function (DataType) {
    DataType["AUDITLOG"] = "auditlog";
    DataType["ALERT"] = "alert";
    DataType["ASSET"] = "asset";
    DataType["CONVERSATION"] = "conversation";
    DataType["ISSUE"] = "issue";
    DataType["ISSUE_TODO"] = "issueToDo";
    DataType["OP"] = "op";
    DataType["OP_TODO"] = "opToDo";
    DataType["OPDEFINITION"] = "opDefinition";
    DataType["OPSCHEDULE"] = "opSchedule";
    DataType["POPDEFINITION"] = "popDefinition";
    DataType["ORGANISATION"] = "organisation";
    DataType["ORGTEMPLATE"] = "orgTemplate";
    DataType["PLACE"] = "place";
    DataType["POSITION"] = "position";
    DataType["REPORT"] = "report";
    DataType["SPT"] = "spt";
    DataType["STAFF"] = "staff";
    DataType["SUPERUSER"] = "superuser";
    DataType["SYSTEMSETTINGS"] = "systemsettings";
    DataType["TASK"] = "task";
    DataType["TEAMBOARD"] = "teamboard";
    DataType["TEAM"] = "team";
    DataType["TEMPLATE"] = "template";
    DataType["INDUSTRY"] = "industry";
    DataType["UPLOADFILE"] = "uploadFile";
    DataType["USER"] = "user";
    DataType["WORKFLOW"] = "workflow";
    DataType["QUESTIONSET"] = "questionSet";
})(DataType = exports.DataType || (exports.DataType = {}));
exports.default = DataType;
function dataTypeLabel(d) {
    switch (d) {
        case DataType.AUDITLOG:
            return lib_i18n_1.default.t('auditlog');
        case DataType.ALERT:
            return lib_i18n_1.default.t('alert');
        case DataType.ASSET:
            return lib_i18n_1.default.t('asset');
        case DataType.CONVERSATION:
            return lib_i18n_1.default.t('conversation');
        case DataType.ISSUE:
            return lib_i18n_1.default.t('issue');
        case DataType.ISSUE_TODO:
            return lib_i18n_1.default.t('issuetodo');
        case DataType.OP:
            return lib_i18n_1.default.t('op');
        case DataType.OP_TODO:
            return lib_i18n_1.default.t('optodo');
        case DataType.OPDEFINITION:
            return lib_i18n_1.default.t('opdefinition');
        case DataType.OPSCHEDULE:
            return lib_i18n_1.default.t('opschedule');
        case DataType.POPDEFINITION:
            return lib_i18n_1.default.t('popdefinition');
        case DataType.ORGANISATION:
            return lib_i18n_1.default.t('organisation');
        case DataType.ORGTEMPLATE:
            return lib_i18n_1.default.t('orgtemplate');
        case DataType.PLACE:
            return lib_i18n_1.default.t('place');
        case DataType.POSITION:
            return lib_i18n_1.default.t('position');
        case DataType.REPORT:
            return lib_i18n_1.default.t('report');
        case DataType.SPT:
            return lib_i18n_1.default.t('spt');
        case DataType.STAFF:
            return lib_i18n_1.default.t('staff');
        case DataType.SUPERUSER:
            return lib_i18n_1.default.t('superuser');
        case DataType.SYSTEMSETTINGS:
            return lib_i18n_1.default.t('systemsettings');
        case DataType.TASK:
            return lib_i18n_1.default.t('task');
        case DataType.TEAMBOARD:
            return lib_i18n_1.default.t('teamboard');
        case DataType.TEAM:
            return lib_i18n_1.default.t('team');
        case DataType.TEMPLATE:
            return lib_i18n_1.default.t('template');
        case DataType.INDUSTRY:
            return lib_i18n_1.default.t('industry');
        case DataType.UPLOADFILE:
            return lib_i18n_1.default.t('uploadfile');
        case DataType.USER:
            return lib_i18n_1.default.t('user');
        case DataType.WORKFLOW:
            return lib_i18n_1.default.t('workflow');
        case DataType.QUESTIONSET:
            return lib_i18n_1.default.t('questionset');
    }
}
exports.dataTypeLabel = dataTypeLabel;
